module.exports = __webpack_public_path__ + "img/logomap.df1d818e.png";